var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.26348 1.50912C6.94765 0.746225 6.11504 0.34017 5.31934 0.557553L1.70996 1.54193C0.996289 1.7388 0.5 2.38685 0.5 3.12513C0.5 13.2724 8.72773 21.5001 18.875 21.5001C19.6133 21.5001 20.2613 21.0038 20.4582 20.2902L21.4426 16.6808C21.66 15.8851 21.2539 15.0525 20.491 14.7367L16.5535 13.096C15.885 12.8171 15.1098 13.0099 14.6545 13.5718L12.9975 15.5939C10.11 14.2281 7.77207 11.8902 6.40625 9.00267L8.42832 7.34974C8.99023 6.89037 9.18301 6.11927 8.9041 5.45072L7.26348 1.51322V1.50912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.dc29b1084a5512467b50cb232dfd2811.svg";
export { ForwardRef as ReactComponent };